import request from '@/config/axios'

export interface AgentLedgerVO {
  id?: number
  agentId?: number
  agentName?: string
  parentAgentId?: number
  softwareId?: string
  merchantId?: number
  period?: string
  bizType?: string
  bizId?: string
  basisAmount?: number
  rate?: number
  amount?: number
  ruleVersion?: number
  shareRole?: number
  settled?: boolean
  createTime?: string
}

export const getLedgerPage = (params: any) =>
  request.get<{ list: AgentLedgerVO[]; total: number }>({ url: '/agent/ledger/page', params })

export const exportLedgerExcel = (params: any) =>
  request.download({ url: '/agent/ledger/export-excel', params })
